import { render, staticRenderFns } from "./BannerSettingAdd.vue?vue&type=template&id=d06e2f24&scoped=true"
import script from "./BannerSettingAdd.vue?vue&type=script&lang=js"
export * from "./BannerSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./BannerSettingAdd.vue?vue&type=style&index=0&id=d06e2f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06e2f24",
  null
  
)

export default component.exports